import React from 'react'
import axios from 'axios'

class LearnerActiveServices extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      services: [],
      loaded: false,
    }
  }

  componentDidMount() {
    axios.get(`/api/sales/enquiries/${this.props.enquiryId}/learner_services`, {
      params: { enquiry_learner_id: this.props.enquiryLearnerId }
    })
    .then((response) => {
      this.setState({ services: response.data.services, loaded: true })
    })
    .catch(() => {
      this.setState({ loaded: true })
    })
  }

  formatTime(time) {
    return new Date(time).toLocaleString('en-ZA', {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit',
    })
  }

  serviceDetail(service) {
    if (service.type === 'TutoringPlan') {
      const parts = []
      if (service.lesson?.tutor?.name) {
        parts.push(`Tutor ${service.lesson.tutor.name}`)
      }
      if (service.lesson?.time) {
        parts.push(`${service.lesson.period || 'next'} lesson ${this.formatTime(service.lesson.time)}`)
      }
      if (service.lessons_remaining != null) {
        parts.push(`${service.lessons_remaining} lesson${service.lessons_remaining === 1 ? '' : 's'} remaining`)
      }
      return parts.join(' · ')
    }

    if (service.type === 'Classrooms::Classroom') {
      const parts = []
      if (service.teacher?.name) {
        parts.push(`Teacher ${service.teacher.name}`)
      }
      if (service.next_class?.time) {
        parts.push(`next class ${this.formatTime(service.next_class.time)}`)
      } else if (service.scheduled_times) {
        parts.push(service.scheduled_times)
      }
      return parts.join(' · ')
    }

    if (service.type === 'Coachbit::Subscription') {
      const parts = []
      if (service.coachbit_order?.checkin_days) {
        parts.push(`${service.coachbit_order.checkin_days} check-in${service.coachbit_order.checkin_days > 1 ? 's' : ''} per week`)
      }
      if (service.payment_info?.next_billing_at) {
        parts.push(`next billing ${new Date(service.payment_info.next_billing_at).toLocaleDateString()}`)
      }
      return parts.join(' · ')
    }

    return null
  }

  render() {
    if (!this.state.loaded) {
      return null
    }

    return (
      <React.Fragment>
        <div className="mb-2 text-xs font-semibold uppercase tracking-wider text-muted-foreground">Active Services</div>
        {this.state.services.length === 0 ? (
          <div className="mb-2 text-sm italic text-muted-foreground">No active services.</div>
        ) : (
          <div className="mb-2 flex flex-col gap-2">
            {this.state.services.map((service) => (
              <div key={`${service.type}-${service.id}`} className="rounded-md border p-2 text-sm">
                <div className="font-medium">{service.name}</div>
                {this.serviceDetail(service) && (
                  <div className="text-xs text-muted-foreground">{this.serviceDetail(service)}</div>
                )}
              </div>
            ))}
          </div>
        )}
      </React.Fragment>
    )
  }
}

export default LearnerActiveServices
